module.exports = __webpack_public_path__ + "img/jacket-back-sub-setIn-zipper.867d89d3.png";